import { createAuthenticatedClient } from "../authenticatedClient";
import { API_BASE_URL } from "../config";
import { safeValidate } from "../safeValidate";
import {
  CreateViewRequestPayload,
  SavedFilterViewsResponse,
  savedFilterViewsSchema,
  UpdateViewRequestPayload,
} from "../schemas/policiesSaveFilterView.schema";

const policiesClient = createAuthenticatedClient(`${API_BASE_URL}/ispm/v1`);

export const getHashedUsername = () => {
  return btoa(localStorage.getItem("username") || "unknown_user");
};

export const policiesSaveFilterViewApi = {
  getSaveViewList: async (): Promise<SavedFilterViewsResponse> => {
    const hashedUsername = getHashedUsername();

    const data = await policiesClient.get<SavedFilterViewsResponse>(
      "/view?viewType=policy",
      {
        headers: { username: hashedUsername },
      },
    );
    const validated: SavedFilterViewsResponse = safeValidate(
      savedFilterViewsSchema,
      data,
      "getSaveViewList",
    ) as SavedFilterViewsResponse;
    return validated;
  },
  updateSaveFilterView: async (payload: UpdateViewRequestPayload) => {
    const hashedUsername = getHashedUsername();
    const { id, ...payloadData } = payload;
    return await policiesClient.put<unknown>(
      `/view/${id}?viewType=policy`,
      { ...payloadData },
      { headers: { username: hashedUsername } },
    );
  },
  createSaveFilterView: async (payload: CreateViewRequestPayload) => {
    const hashedUsername = getHashedUsername();
    return await policiesClient.post<unknown>(
      "/view?viewType=policy",
      payload,
      {
        headers: { username: hashedUsername },
      },
    );
  },
  deleteSaveFilterView: async (viewId: number): Promise<void> => {
    const hashedUsername = getHashedUsername();
    await policiesClient.delete(`/view/${viewId}?viewType=policy`, {
      headers: { username: hashedUsername },
    });
  },
};
